import React, { useEffect, useState } from 'react'
import Page from '../../layouts/Page'
// import { useParams } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';
import Loading from '../../components/Loading';
import useApi from '../../hooks/useApi';
import axios from 'axios';
import { customStringify } from '../../utils';
import { network_tl } from '../../translations';
import RetryApi from '../../components/RetryApi';
import Container from './Container';

function InfluencerDetail() {
    const { Axios } = useApi();
    const location = useLocation();
    const { id } = useParams();
    const [error, setError] = useState(false);
    const [data, setdata] = useState({});
    const intl = useIntl();
    const [loading, setLoading] = useState(true);
    const [refresh, setRefresh] = useState(false);
    const previousPath = location.state?.from || "discovery";
    console.log("previousPath", previousPath);
    console.log("location.state?.from", location.state?.from);
  
    const refreshListing = () => {
      setRefresh(!refresh);
    }
  
    const getData = async () => {
      setLoading(true);
      setError(false);
      try {
  
        const result = await Axios.get(`api/influencer/${id}`);
        setdata(result.data.payload);
        setLoading(false);
      } catch (e) {
        if (axios.isCancel(e)) {
  
        } else if (e.response) {
          setError(customStringify(e.response.data.description))
        } else {
          setError(network_tl(intl))
        }
        setLoading(false)
      }
    }
  
    useEffect(() => {
      getData();
    }, [refresh])
  return (
    <Page
    title={<FormattedMessage id="influencer_detail" defaultMessage={"Influencer Detail"} />}
    prevPage
        breadcrumbs={[
            {
                title: <FormattedMessage id="influencee" defaultMessage={"influencee"} />,
                link: "/"
            },
            {
                title: <FormattedMessage id={`${previousPath ? previousPath=== "favorite-influencers"? "favorite_influencers": previousPath : "discovery"}`} defaultMessage={"Discovery"} />,
                link: `/${previousPath ? previousPath : "discovery"}`
            },
            {
                title: <span className='capitalize'>{data?.user?.name} {data?.user?.sur_name}</span>,
                link: "/influencer/" + id
              },

        ]}>
        
        {
        loading && !error ? (
          <Loading />

        ) : !loading && error ? (
          <RetryApi error={error} retry={getData} />
        ) : (
          <Container data={data} refreshListing={refreshListing} />
        )
      }

    
    </Page>
  )
}

export default InfluencerDetail